import {
  eachDayOfInterval, endOfDay, endOfMonth, endOfWeek,
  startOfDay, startOfMonth, startOfWeek
} from 'date-fns';
import { TCalendarInervalFilter } from '../types';

export const getDaysOfInterval = (day: Date, mode: TCalendarInervalFilter): Date[] => (
  eachDayOfInterval({
    start: new Date(getStartInterval(day, mode)),
    end: new Date(getEndInterval(day, mode)),
  })
);


export const getStartInterval = (day: Date, mode: TCalendarInervalFilter) => {
  const currentMonthFirstDay = getInterval.start[mode](day);
  return mode === 'day'
    ? currentMonthFirstDay
    : startOfWeek(currentMonthFirstDay, { weekStartsOn: 1 });
};

export const getEndInterval = (day: Date, mode: TCalendarInervalFilter) => {
  const endOfCurrentMonth = endOfMonth(day);
  switch (mode) {
    case 'month':
      return endOfWeek(endOfCurrentMonth, { weekStartsOn: 1 });
    case 'week':
      return endOfWeek(day, { weekStartsOn: 1 })
    case 'day':
      return endOfDay(day);
  }
};

type TGetInterval = Record<'start' | 'end', Record<TCalendarInervalFilter, (date: number | Date) => Date>>;

export const getInterval: TGetInterval = {
  start: {
    month: startOfMonth,
    week: (date: number | Date) => startOfWeek(date, { weekStartsOn: 1 }),
    day: startOfDay
  },
  end: {
    month: endOfMonth,
    week: (date: number | Date) => endOfWeek(date, { weekStartsOn: 1 }),
    day: endOfDay
  }
};

type TGetViewCalendar = Record<TCalendarInervalFilter, (date: Date) => Date[]>;

export const getViewCalendar: TGetViewCalendar = {
  month: (date: Date) => getDaysOfInterval(date, 'month'),
  week: (date: Date) => getDaysOfInterval(date, 'week'),
  day: (date: Date) => [date]
};
